<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('invoices') }} {{ $t('customers') }}
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        sm="4"
        lg="3"
        class="d-flex align-items-end mb-1"
      >
        <b-form-group
          class="mr-1 mb-0 w-100"
          :label="$t('startDate')"
        >
          <b-form-datepicker
            v-model="quoteFilters.startDate"
            reset-button
            @input="getQuotesWithFilters"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="4"
        lg="3"
        class="d-flex align-items-end mb-1"
      >
        <b-form-group
          class="mr-1 mb-0 w-100"
          :label="$t('endDate')"
        >
          <b-form-datepicker
            v-model="quoteFilters.endDate"
            reset-button
            @input="getQuotesWithFilters"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="4"
        lg="3"
        class="d-flex align-items-end mb-1"
      >
        <b-form-group
          class="mr-1 mb-0 w-100"
          :label="$t('customer')"
        >
          <vue-bootstrap-typeahead
            v-model="costumerQuery"
            :placeholder="$t('search')"
            :data="[...customersResults]"
            :serializer="item => item.name"
            :show-all-results="true"
            :max-matches="5"
            @hit="selectCustomer($event)"
          >
            <template
              slot="suggestion"
              slot-scope="{ data }"
            >
              <div>
                <span style="font-size: 12px">{{ data.name }}</span>
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </b-form-group>
      </b-col>
      <b-col
        sm="4"
        lg="3"
        class="d-flex align-items-end mb-1"
      >
        <b-overlay :show="downloadLoading">
          <b-button
            class=""
            variant="success"
            @click="download"
          >
            {{ $t('download') }}
          </b-button>
        </b-overlay>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-overlay :show="loading">
          <customer-invoices-table :invoices="quotes" />
        </b-overlay>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-pagination
          :value="quotesPagination.page"
          :total-rows="quotesPagination.total_objects"
          :per-page="quotesPagination.per_page"
          aria-controls="my-table"
          @change="nextPage($event)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import _ from 'underscore'
import CustomerInvoicesTable from '@/components/invoice/CustomerInvoicesTable.vue'

export default {
  components: {
    CustomerInvoicesTable,
  },

  data() {
    return {
      loading: false,
      invoices: [],
      downloadLoading: false,
      selectedCustomer: { id: null },
      newInvoice: {
        name: '',
        folio: '',
        file: null,
      },
      quoteFilters: {
        startDate: null,
        endDate: null,
      },
      costumerQuery: '',
      customersResults: [],
    }
  },

  computed: {
    ...mapGetters('quotes', ['quotes', 'quotesPagination']),
    ...mapGetters('projects', ['project']),
    ...mapGetters('suppliers', {
      files: 'newProviderFiles',
    }),
  },

  watch: {
    costumerQuery: _.debounce(function search(query) {
      if (query.length === 0) {
        this.selectedCustomer.id = null
        this.loading = true
        this.fetchQuotes({ by_is_invoiced: true }).finally(() => {
          this.loading = false
        })
        return
      }
      this.fetchCustomers({
        byName: query,
        by_is_invoiced: true,
        meta: {
          pagination: {
            per_page: 10,
          },
        },
      }).then(response => {
        this.customersResults = JSON.parse(JSON.stringify(response.data))
      })
      // this.loading = false
    }, 500),
  },

  created() {
    this.loading = true
    this.fetchQuotes({ by_is_invoiced: true }).finally(() => {
      this.loading = false
    })
  },

  destroyed() {
    this.clearQuotes()
    // this.clearProject({})
  },

  methods: {
    ...mapMutations('quotes', {
      clearQuotes: 'CLEAR_QUOTES',
      changePagination: 'CHANGE_PAGINATION',
    }),
    ...mapActions('quotes', ['fetchQuotes', 'downloadQuotes']),
    ...mapActions('customers', ['fetchCustomers']),

    selectCustomer(customer) {
      this.selectedCustomer.id = customer.id
      this.getQuotesWithFilters()
    },

    async getQuotesWithFilters() {
      this.loading = true
      await this.fetchQuotes({
        by_customer: this.selectedCustomer.id,
        by_is_invoiced: true,
        by_invoiced_at: {
          start_date: this.quoteFilters.startDate,
          end_date: this.quoteFilters.endDate,
        },
        meta: { pagination: this.quotesPagination },
      })
      this.loading = false
    },

    nextPage(value) {
      this.changePagination({ field: 'page', value })
      this.getQuotesWithFilters()
    },
    download() {
      this.downloadLoading = true
      this.downloadQuotes({
        by_is_invoiced: true,
        by_customer: this.selectedCustomer.id,
        by_invoiced_at: {
          start_date: this.quoteFilters.startDate,
          end_date: this.quoteFilters.endDate,
        },
      }).finally(() => {
        this.downloadLoading = false
      })
    },
  },
}
</script>

<style></style>
